export class TechMessage {
  id?: string;
  user?: string;
  emails: string[] = [];
  stripeLink?: string;
  deadline?: Date;
  price?: number;
  createdAt?: Date;

  constructor(json?: any) {
    if (!json) return;
    this.id = json['_id'] || json['id'];
    this.user = json['user'];
    this.emails = json['emails'];
    this.stripeLink = json['stripeLink'];
    this.deadline = json['deadline'];
    this.price = json['price'] ? parseInt(json['price']) / 100 : json['price'];
    this.createdAt = json['createdAt']
      ? new Date(json['createdAt'])
      : undefined;
  }
}
